import React, { ReactNode, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

export interface BubbleTooltipProps {
  text?: string;
  textRender?: (text: string) => ReactNode;
  children: ReactNode;
  className?: string;
  position?: 'center' | 'left';
}

export default function BubbleTooltip({
  text,
  textRender,
  children,
  className,
  position = 'center',
}: BubbleTooltipProps) {
  const triggerRef = useRef<HTMLDivElement>(null);
  const [coords, setCoords] = useState<{ top: number; left: number } | null>(null);

  if (!text && !textRender) return <>{children}</>;

  function handleMouseEnter() {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const centerX = rect.left + rect.width / 2;
    setCoords({
      top: rect.top + window.scrollY - 8,
      left: position === 'left' ? centerX - 100 : centerX,
    });
  }

  function handleMouseLeave() {
    setCoords(null);
  }

  const render = textRender || ((txt: string) => <>{txt}</>);

  return (
    <div
      ref={triggerRef}
      className={`relative inline-block ${className ?? ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {coords &&
        ReactDOM.createPortal(
          <div
            className="pointer-events-none"
            style={{ position: 'absolute', top: coords.top, left: coords.left, zIndex: 9999 }}
          >
            <div
              className="p-1 rounded-lg bg-black text-white text-center text-sm"
              style={{
                maxWidth: 240,
                transform: position === 'left' ? 'translateY(-100%)' : 'translate(-50%, -100%)',
              }}
            >
              {render(text || '')}
              <span
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: position === 'left' ? '83%' : '50%',
                  marginLeft: -5,
                  borderWidth: 5,
                  borderStyle: 'solid',
                  borderColor: '#000 transparent transparent transparent',
                }}
              />
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}
